<script>
  export let imageLocation;
</script>

<main>
  <img src={imageLocation} />
</main>

<style>
  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    box-shadow: 0px 0px 2px 2px #88c3ea;
    margin: 3px;
  }
</style>